import React from "react";

import styled from "styled-components";

import Button, { BUTTON_STYLES } from "components/atoms/button";

const Container = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin: 24px 0 0 0;
    width: 100%;
    height: 32px;
`;

function AbstractModalFooter(props) {
    return (
        <Container>
            {props.onlyLeftBtn ? (
                <Button {...BUTTON_STYLES.modalSecondary} onClick={props.leftOnClick} buttonText={props.leftBtnText} />
            ) : (
                <>
                    <Button
                        {...BUTTON_STYLES.modalSecondary}
                        onClick={props.leftOnClick}
                        buttonText={props.leftBtnText}
                    />
                    <Button
                        {...BUTTON_STYLES.modalPrimary}
                        onClick={props.rightOnClick}
                        margin={"0 0 0 4px"}
                        buttonText={props.rightBtnText}
                        disabled={props.disabled}
                    />
                </>
            )}
        </Container>
    );
}

export default AbstractModalFooter;
